import { useState, useEffect } from "react";
import {Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/meto-w__2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = [ "Web Developer", "Web Designer", "UI/UX Designer" ];
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);
    const period = 2000;
    useEffect(() => {
        let ticker = setInterval(() => {
            tick();
        }, delta);
        return () => { clearInterval(ticker) };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);
        if (isDeleting) {
            setDelta(prevDelta => prevDelta / 2);
        }

        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(period);
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    };
  return (
    <section className="banner" id="home">
        < Container>
        <Row className="align-items-center">
            <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
                {({ isVisible }) => (
                    <div className={isVisible ? 'animate__animated animate__fadeIn' : 'animate__animated animate__fadeOut'}>
                        <span className= "tagline" >Welcome to My Portfolio</span>
                        <h1>{`Hi! I'm Abu Bin Naser `} <span className="wrap" >{text}</span> </h1>
                    </div>
                )}
            </TrackVisibility>
            <p>
         I'm a passionate web developer with a strong interest in building user-friendly and responsive websites. I 
love turning creative ideas into functional digital experiences and constantly improving my skills in modern 
web technologies.
            </p>
            <button onClick={() => console.log('connect')}>Let's Connect <ArrowRightCircle size={25} /> </button>
            </Col>
            <Col xs={12} md={6} xl={5}>
            <img src={headerImg} alt="Header Img" /> 
            </Col>
            </Row>
        </Container>
        </section>
  )
};
